Librarian.Modules.NewContent = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onDataLoaded"],

    options: {
        classPrefix: "modules-newcontent-",
        catPath: null,
        catType: Librarian.catType.file,
        rootCat: 0,
        orderBy: "FileDBImportDate",
        order: "desc",
        imageSize: "sm",
        showViewAll: true,
        dateField: "importdate",
        dateFormat: "%m/%d/%Y %l:%M %p",
        onPostRender: null,
        useGetSendData: true
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || !this.options.catPath)
            return;

        this.parent();

        var method = "getfiles";
        if (this.options.catType == Librarian.catType.globalFavorite) {
            this.options.rootCat = Librarian.specialCategories.GlobalFavorites.CatId;
            method = "getcg";
            if (this.options.orderBy == "FileDBImportDate")
                this.options.orderBy = "GroupLastModDate";
            if (this.options.dateField == "importdate")
                this.options.dateField = "lastmoddate";
        }

        var options = {
            url: Librarian.path.getMethodUrl(method) + "&out=ujson&orderby=" + this.options.orderBy + "&order=" + this.options.order + "&perpage=1&pcid=" + this.options.rootCat + "&cpath=" + this.options.catPath,
            onSuccess: this.onDataLoaded,
            onFailure: Librarian.Utils.onFailure
        };

        // If we have a custom data function
        if (this.options.useGetSendData && (typeof Library != "undefined") && (typeof Library.getSendData == "function")) {
            // Get the data to send and check that it is valid
            var data = Library.getSendData({
                cattype: this.options.catType
            }, options.url);

            if (data) {
                // If the given data is an object, stringify it
                if (typeof data.data == "object")
                    data.data = JSON.stringify(data.data);
                // Convert the data to Base64
                if (typeof Base64 != "undefined")
                    data.data = Base64.encode(data.data);

                // And save it
                options.data = data.data;
                options.method = "post";
                options.url = data.url;
            }
        }

        this.request = new Librarian.Request.JSON(options);
        this.request.send();
    },

    onDataLoaded: function(json) {
        if (!json)
            return;

        // Build the link to this category for use later
        var catId = json.CatId || 0,
            catLink = "#catid=" + catId + "&type=" + this.options.catType,
            files = json.Files,
            groups = json.Groups,
            info = null;

        // Change the data to lower case so the thumbnail and preview window can use it
        if (files && files[0])
            info = Object.toLowerKeys(files[0]);
        else if (groups && groups[0])
            info = Object.toLowerKeys(groups[0]);

        // If we have at least one file, build the data
        if (info) {
            // Create the image with the correct image and class
            var imageEl = new Element("img", {
                "src": Librarian.Utils.getThumbnailUrl(this.options.imageSize, info),
                "class": (this.options.classPrefix || '') + "image"
            }).injectInside(this.containerEl);

            // Save the data in the image so we can open the preview window using it
            imageEl.data = info;
            imageEl.parentData = Object.toLowerKeys(json);
            imageEl.addOnClick(function() {
                Librarian.PreviewWindow.openPreviewWindow(this.data, this.parentData);
            });

            // Add the file name if its available
            if (info.name) {
                new Element("a", {
                    "text": info.name,
                    "href": catLink + "&fileid=" + info.fileid + "&groupid=" + info.groupid,
                    "class": (this.options.classPrefix || '') + "name"
                }).injectInside(this.containerEl);
            }

            // Add the file date if its available and we are told to show it
            if (this.options.dateField && info[this.options.dateField]) {
                var date = info[this.options.dateField];
                new Element("span", {
                    "html": Librarian.Utils.extractDateFromString(date).format(this.options.dateFormat),
                    "class": (this.options.classPrefix || '') + "date"
                }).injectInside(this.containerEl);
            }

            // Add the file description if its available
            if (info.description) {
                new Element("span", {
                    "html": info.description,
                    "class": (this.options.classPrefix || '') + "description"
                }).injectInside(this.containerEl);
            }
        }

        // If we are told to show the "View All" link, add that too
        if (this.options.showViewAll) {
            // Add it into its own container so that it can be pinned to the bottom
            var linkEl = new Element("div", {
                "class": (this.options.classPrefix || '') + "viewall"
            }).injectInside(this.wrapperEl);

            var viewAllLinkEl = new Element("a", {
                "html": Librarian.Lang.getString("modules_newcontent_view_all"),
                "class": (this.options.classPrefix || '') + "viewall-link"
            });
            viewAllLinkEl.addEvent('click', function () {
                Librarian.Utils.getPath(Object.toLowerKeys(json), function(path) {
                    Librarian.Utils.selectTreeNodeByPath(treeView, path);
                });             
            }.bind(this));
            viewAllLinkEl.injectInside(linkEl);

            // Adjust the height of the container to fit the link
            var linkHeight = linkEl.getHeight(),
                contHeight = this.containerEl.getHeight() - linkHeight - 10;

            if (!isNaN(contHeight))
                this.containerEl.setStyle("height", contHeight + "px");
        }

        if (typeof this.options.onPostRender == "function")
            this.options.onPostRender(this.wrapperEl);
    }
});